import { isMobileTeamViewport } from "./teamNavigation";
import { openWindowWithTabAuth } from "./tabAuthStorage";

/**
 * Abre a solicitação em janela popup (/popup-call/:id) no desktop
 * (inclui app Chrome/PWA instalado no computador).
 * Só no mobile (viewport estreito) navega in-app — window.open é frágil/bloqueado.
 */
export function openCallPopupWindow(conversationId, { navigate } = {}) {
  const numeric = Number(conversationId);
  if (!Number.isFinite(numeric) || numeric <= 0) return null;
  const id = String(Math.trunc(numeric));

  // Não usar display-mode:standalone aqui: no desktop o app instalado
  // também reporta standalone e precisa abrir /popup-call em nova janela.
  if (isMobileTeamViewport()) {
    if (typeof navigate === "function") {
      navigate("/chat", { state: { openConversationId: numeric } });
      return null;
    }
    try {
      window.location.assign(`/chat/${encodeURIComponent(id)}`);
    } catch (_) {
      /* ignore */
    }
    return null;
  }

  const width = window.screen.width;
  const height = window.screen.height;
  // URL absoluta: location.assign em about:blank (tab auth) não resolve path relativo.
  const url = new URL(`/popup-call/${encodeURIComponent(id)}`, window.location.origin).href;
  const windowName = `ConversationPopup-${id}`;
  const features = `width=${width},height=${height},top=0,left=0,scrollbars=no,toolbar=no,location=no,status=no,menubar=no`;

  const win = openWindowWithTabAuth(url, windowName, features);
  if (win) return win;

  // App Chrome instalado / bloqueio parcial: tenta sem features (nova janela do PWA).
  return openWindowWithTabAuth(url, windowName);
}
